import z from "zod";

export const CHANGE_REQUEST_OPERATION_REF_PREFIX = "@op:";

export const CHANGE_REQUEST_DERIVED_REF_SEPARATOR = "#";

export const ChangeRequestOperationRefScheme = z
  .string()
  .startsWith(CHANGE_REQUEST_OPERATION_REF_PREFIX);

export type ChangeRequestOperationRef = z.infer<
  typeof ChangeRequestOperationRefScheme
>;

export const isChangeRequestOperationRef = (
  value: string,
): value is ChangeRequestOperationRef =>
  value.startsWith(CHANGE_REQUEST_OPERATION_REF_PREFIX);

export const toChangeRequestOperationRef = (
  operationId: string,
  derivedKey?: string,
): ChangeRequestOperationRef =>
  derivedKey === undefined
    ? `${CHANGE_REQUEST_OPERATION_REF_PREFIX}${operationId}`
    : `${CHANGE_REQUEST_OPERATION_REF_PREFIX}${operationId}${CHANGE_REQUEST_DERIVED_REF_SEPARATOR}${derivedKey}`;

export const toChangeRequestAppliedIdKey = (
  operationId: string,
  derivedKey?: string,
): string =>
  derivedKey === undefined
    ? operationId
    : `${operationId}${CHANGE_REQUEST_DERIVED_REF_SEPARATOR}${derivedKey}`;

export const parseChangeRequestOperationRef = (
  operationRef: ChangeRequestOperationRef,
): { operationId: string; appliedIdKey: string } => {
  const appliedIdKey = operationRef.slice(
    CHANGE_REQUEST_OPERATION_REF_PREFIX.length,
  );
  const [operationId = appliedIdKey] = appliedIdKey.split(
    CHANGE_REQUEST_DERIVED_REF_SEPARATOR,
  );
  return { operationId, appliedIdKey };
};

export const idOrOperationRef = <T extends z.ZodType<string>>(idScheme: T) =>
  z.union([idScheme, ChangeRequestOperationRefScheme]);

export const nullableIdOrOperationRef = <T extends z.ZodType<string>>(
  idScheme: T,
) => z.union([idScheme, ChangeRequestOperationRefScheme]).nullable();

export const idOrOperationRefArray = <T extends z.ZodType<string>>(
  idScheme: T,
) => z.array(z.union([idScheme, ChangeRequestOperationRefScheme]));
